// extracted by mini-css-extract-plugin
export default {"base":"-cm_1f3fc6c2","small":"-cm_5f265b0c","mini":"-cm_ac5e5a8f","tiny":"-cm_544a9a1c","icon":"-cm_7969672f","link":"-cm_e8fa5978","loading":"-cm_f12a239b"};